import { Image } from "@chakra-ui/react";
import { useMerchant } from "../hooks/useMerchant";
import { useMediaBust, withCacheBust } from "../helpers/mediaUrl";

const MerchantLogo = () => {
  const { merchant } = useMerchant();
  const mediaBust = useMediaBust();
  const src = merchant?.logoUrl
    ? withCacheBust(merchant.logoUrl, mediaBust)
    : undefined;

  return (
    <>
      {src && <Image src={src} alt="Merchant Logo" height="40px" />}
    </>
  );
};

export default MerchantLogo;
